import React from "react";

export default function eyebrowAngry(): React.ReactElement {
  return (
    <svg
      style={{
        position: "absolute",
        width: "80%",
        height: "13%",
        top: 0,
      }}
      width="149"
      height="48"
      viewBox="0 0 149 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Left eyebrow - angry/furrowed */}
      <path
        d="M20 35L50 25"
        stroke="black"
        strokeWidth="5"
        strokeLinecap="round"
      />
      {/* Right eyebrow - angry/furrowed */}
      <path
        d="M99 15L129 25"
        stroke="black"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  );
}
